<!-- Patreon Card Here -->
<div class="">

    <div class="">
        <div class="patreon-card" style="border: none; background-color: #ffebda;">

            <div class="row no-gutters cl_animation1">

                <div class="col-md-8" style="text-align: center;">
                    <div class="card-body patreon-body">
                        <h5 class="card-title patreon_head">Want Early Build access ? </h5>
                        <p class="pat-card-sum">Join us on patreon for
                            exclusivity.
                            Choose the tier that suits your requirement and it starts from 3$ </p>
                        <br>

                        <div>
                            <footer class="blockquote-footer"> Exclusive build & features that aren't available for
                                public
                            </footer>
                            <footer class="blockquote-footer"> Get latest bugfixes and active development builds
                            </footer>
                            <footer class="blockquote-footer"> Early Build access with source update</footer>
                            <footer class="blockquote-footer"> Sponsor & VIP Tag in our Website</footer>
                            <footer class="blockquote-footer"> Personal Build with Requested Feature</footer>
                            <footer class="blockquote-footer"> If needed then private chat support for builds related
                                issues</footer>
                            <footer class="blockquote-footer"> Access to full source</footer>
                            <footer class="blockquote-footer"> Exclusive voting power</footer>
                            <footer class="blockquote-footer"> Full Guidance and Support from TEAM</footer>
                        </div>
                        <br>

                    </div>
                </div>

                <div class="col-md-4 patreon-card-right">

                    <img src="./assets/images/patreon.png" class="card-img patreon_new-cl" alt="img">

                    <a target="_blank" href="https://www.patreon.com/join/uglykid24">
                        <p> <a class="btn shadow patreon-btn" style="display: inline-block;">
                                <svg width="22" height="22" viewBox="0 -4.5 256 256" version="1.1" class="bi bi-patreon"
                                    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid">
                                    <g>
                                        <path
                                            d="M45.1355837,0 L45.1355837,246.35001 L0,246.35001 L0,0 L45.1355837,0 Z M163.657111,0 C214.65668,0 256,41.3433196 256,92.3428889 C256,143.342458 214.65668,184.685778 163.657111,184.685778 C112.657542,184.685778 71.3142222,143.342458 71.3142222,92.3428889 C71.3142222,41.3433196 112.657542,0 163.657111,0 Z"
                                            fill="#ffffff"></path>
                                    </g>
                                </svg> Join us on Patreon
                            </a>
                        </p>
                    </a>

                    <a target="_blank" href="https://www.buymeacoffee.com/Uglykid">
                        <p> <a class="btn shadow patreon-btn" style="display: inline-block; letter-spacing: 2px;">
                                <svg fill="#ffffff" width="26" height="26" class="bi bi-patreon" viewBox="0 0 24 24"
                                    role="img" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="m20.216 6.415-.132-.666c-.119-.598-.388-1.163-1.001-1.379-.197-.069-.42-.098-.57-.241-.152-.143-.196-.366-.231-.572-.065-.378-.125-.756-.192-1.133-.057-.325-.102-.69-.25-.987-.195-.4-.597-.634-.996-.788a5.723 5.723 0 0 0-.626-.194c-1-.263-2.05-.36-3.077-.416a25.834 25.834 0 0 0-3.7.062c-.915.083-1.88.184-2.75.5-.318.116-.646.256-.888.501-.297.302-.393.77-.177 1.146.154.267.415.456.692.58.36.162.737.284 1.123.366 1.075.238 2.189.331 3.287.37 1.218.05 2.437.01 3.65-.118.299-.033.598-.073.896-.119.352-.054.578-.513.474-.834-.124-.383-.457-.531-.834-.473-.466.074-.96.108-1.382.146-1.177.08-2.358.082-3.536.006a22.228 22.228 0 0 1-1.157-.107c-.086-.01-.18-.025-.258-.036-.243-.036-.484-.08-.724-.13-.111-.027-.111-.185 0-.212h.005c.277-.06.557-.108.838-.147h.002c.131-.009.263-.032.394-.048a25.076 25.076 0 0 1 3.426-.12c.674.019 1.347.067 2.017.144l.228.031c.267.04.533.088.798.145.392.085.895.113 1.07.542.055.137.08.288.111.431l.319 1.484a.237.237 0 0 1-.199.284h-.003c-.037.006-.075.01-.112.015a36.704 36.704 0 0 1-4.743.295 37.059 37.059 0 0 1-4.699-.304c-.14-.017-.293-.042-.417-.06-.326-.048-.649-.108-.973-.161-.393-.065-.768-.032-1.123.161-.29.16-.527.404-.675.701-.154.316-.199.66-.267 1-.069.34-.176.707-.135 1.056.087.753.613 1.365 1.37 1.502a39.69 39.69 0 0 0 11.343.376.483.483 0 0 1 .535.53l-.071.697-1.018 9.907c-.041.41-.047.832-.125 1.237-.122.637-.553 1.028-1.182 1.171-.577.131-1.165.2-1.756.205-.656.004-1.31-.025-1.966-.022-.699.004-1.556-.06-2.095-.58-.475-.458-.54-1.174-.605-1.793l-.731-7.013-.322-3.094c-.037-.351-.286-.695-.678-.678-.336.015-.718.3-.678.679l.228 2.185.949 9.112c.147 1.344 1.174 2.068 2.446 2.272.742.12 1.503.144 2.257.156.966.016 1.942.053 2.892-.122 1.408-.258 2.465-1.198 2.616-2.657.34-3.332.683-6.663 1.024-9.995l.215-2.087a.484.484 0 0 1 .39-.426c.402-.078.787-.212 1.074-.518.455-.488.546-1.124.385-1.766zm-1.478.772c-.145.137-.363.201-.578.233-2.416.359-4.866.54-7.308.46-1.748-.06-3.477-.254-5.207-.498-.17-.024-.353-.055-.47-.18-.22-.236-.111-.71-.054-.995.052-.26.152-.609.463-.646.484-.057 1.046.148 1.526.22.577.088 1.156.159 1.737.212 2.48.226 5.002.19 7.472-.14.45-.06.899-.13 1.345-.21.399-.072.84-.206 1.08.206.166.281.188.657.162.974a.544.544 0 0 1-.169.364zm-6.159 3.9c-.862.37-1.84.788-3.109.788a5.884 5.884 0 0 1-1.569-.217l.877 9.004c.065.78.717 1.38 1.5 1.38 0 0 1.243.065 1.658.065.447 0 1.786-.065 1.786-.065.783 0 1.434-.6 1.499-1.38l.94-9.95a3.996 3.996 0 0 0-1.322-.238c-.826 0-1.491.284-2.26.613z" />
                                </svg> Buy Me a Coffee
                            </a>
                        </p>
                    </a>
                </div>

            </div>
        </div>
    </div>

</div>

<ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="7915795682"
    style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto">
</ng2-adsense>

<br>

<div class="container card shadow-light website_animation"
    style="padding: 2rem; background-image: radial-gradient(circle at top left, #00000000 25%, #ffffff99 25.5%, #ffffff2b 36%, #00000000 37%, #00000000 100%), radial-gradient(circle at bottom right, #00000000 34%, #ff8b000f 34.5%, #ff970014 45.5%, #00000000 46%, #ef8a2d26 100%); border: none; border-radius: 2rem;">
    <h2 class="card-title" style="margin-top: 1.5rem;">Alert! Announcement! ⚠️</h2>
    <br>
    <p style="margin-bottom: 1.2rem; font-size: 0.9rem;">Due to toxicity in community <strong
            style="color: #e77d5a;">all builds
            will be exclusive to Patreon/BMC</strong> only. You can use last public release which is free and on our
        website as of now. For
        any further queries contact us via mail or on Telegram. We would like to announce that <strong
            style="color: black;">our latest
            android version is Android 15 (QPR2) </strong> and
        stable release for officially supported device have started on patreon/bmc exclusively. What about Android 14 ?
        Well
        sadly we have to discontinue it as we have all shifted to Android 15.
    </p>

</div>

<p class="headline_device website_animation">Find a carpet that matches your device</p>

<ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="7915795682"
    style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto">
</ng2-adsense>

<!-- Download Card -->
<div class="container down_card website_animation">

    <div class="row device-card shadow-light p-3 mb-5 bg-body rounded" *ngFor="let sel of selectedDevice">

        <div class="col  device-card-left text-center">

            <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="7915795682"
                style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto">
            </ng2-adsense>

            <img src="./assets/images/chrstms-download.png" class="card-img-top rounded mx-auto d-block download-phone"
                alt="device">

            <div class="">
                <p class="card-text  device"> {{sel.deviceName}} </p>
                <p class="card-text devicecode text-muted"> ({{sel.codeName}}) </p>

                <!-- <p class="card-text"> <strong class="deviceinfo">Android 14
                        :</strong> 4.8 <strong class="discon-label">Patreon </strong> **
                </p> -->

                <p *ngIf="sel.eabuildVersion" class="card-text"> <strong class="deviceinfo">Android 15
                        :</strong> {{sel.eabuildVersion}} <span class="badge"
                        [ngClass]="sel.deviceStatus =='active' ? 'active-label' : 'discon-label'">Early Access</span> **
                </p>
                <p *ngIf="!sel.eabuildVersion" class="card-text"> <strong class="deviceinfo">Android 15
                        :</strong> Unavailable </p>

                <!-- <p class="card-text"> <strong class="deviceinfo">Maintainer :</strong> {{sel.maintainer}} </p> -->

                <a  target="_blank" href="{{sel.downloadLink}}">
                    <button class="btn shadow recovery-btn"><a >Recovery</a></button>
                </a>

                <a  target="_blank" href="https://projectelixiros.com/archive">
                    <button class="btn shadow recovery-btn"><a >Extra Files</a></button>
                </a>

                <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="7915795682"
                    style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto">
                </ng2-adsense>
            </div>

        </div>

        <!-- device-card-right -->
        <div class="col justify-content-center device-card-right">

            <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="7915795682"
                style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto">
            </ng2-adsense>

            <a target="_blank" href="{{sel.downloadLink}}">
                <p><a class="btn shadow device-btn">Latest Public build</a></p>
            </a>
            <a target="_blank" href="https://www.patreon.com/posts/introducing-now-120739925">
                <p><a class="btn shadow device-btn">Get Early build</a></p>
            </a>
            <a target="_blank" href="{{sel.guide}}">
                <p><a class="btn shadow device-btn">How to install</a></p>
            </a>
            <a href="https://projectelixiros.com/donate">
                <p><a class="btn shadow device-btn">Support us here</a> </p>
            </a>
            <a target="_blank" href="mailto:support@projectelixiros.com?subject=From Website related to Elixir query">
                <p><a class="btn shadow device-btn">Reach us here</a></p>
            </a>
            <!-- <a target="_blank" href="https://projectelixiros.com/archive">
                <p><a class="btn shadow device-btn">Extra Files | Modules</a></p>
            </a> -->
            <!-- <a target="_blank" href="{{sel.xdaLink}}">
                <p><a  class="btn shadow device-btn">XDA Thread</a></p>
            </a> -->
            <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="7915795682"
                style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto">
            </ng2-adsense>

        </div>

        <!-- Important Note -->
        <div class="container note-download">
            <p style="font-weight: 600; font-size: 1.1rem; text-transform: uppercase; margin-top: 2rem;">** Important
                Note **</p>
            <!-- <footer style="font-weight: 600; font-size: 0.8rem; text-transform: uppercase;" class="blockquote-footer">
                For Recovery and other files : <a target="_blank" href="{{sel.downloadLink}}">
                    <a class="btn shadow recovery-btn">Tap HERE</a>
                </a></footer> -->
            <footer class="blockquote-footer"> Early access for Android 14/15 totally depends on the device and its
                maintainer availability</footer>
            <footer class="blockquote-footer"> Don't fall for mod/cracks etc and you may end up in trouble</footer>
            <footer class="blockquote-footer"> Make sure to check if your device has official support for Android 14/15
                and
                active officially</footer>
            <footer class="blockquote-footer"> <strong class="active-label">Green</strong> and <strong
                    class="discon-label">Red</strong> lable indicates active and discontinued status of the device
                respectively</footer>
            <footer class="blockquote-footer"> For any further queries contact us via mail or on Telegram.</footer>

        </div>
    </div>

    <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="7915795682"
        style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto">
    </ng2-adsense>

</div>

<!-- Important-Note Card / Archived Builds -->
<div class="container shadow-light download-note website_animation"
    style="padding: 2rem; background-color: white; border-radius: 1.5rem;">
    <div class="row justify-content-center">
        <div class=" mb-3 card-radius">
            <div class="row no-gutters">

                <div class="col-md-4 mb-align" style="text-align: center;">
                    <img src="./assets/images/archived-files.webp" class="card-img img-fluid down-carpet-img"
                        style="width: 19rem; margin-top: 1rem;" alt="avatar">
                </div>

                <div class="col-md-8">
                    <div class="card-body">
                        <h1 class="support_line">** Disclaimer & Important Note ** </h1>

                        <footer class="blockquote-footer"> Your warranty is now void after unlocking bootloader</footer>
                        <footer class="blockquote-footer"> Project Elixir is not responsible for any damage you made to
                            your device</footer>
                        <footer class="blockquote-footer"> You have been warned!</footer>
                        <footer class="blockquote-footer"> We are not responsible for anything that may happen to your
                            phone by installing any kernels/mods/crack</footer>
                        <footer class="blockquote-footer"> You do it at your own risk and take the responsibility upon
                            yourself </footer>
                        <footer class="blockquote-footer"> You are not to blame Project Elixir or its respected
                            developers for any of your loss.</footer>
                        <footer class="blockquote-footer"> Don't fall for mod/cracks etc and you may end up in trouble.
                            In such scenarios, you are not to blame us</footer>
                        <footer class="blockquote-footer"> Be careful while going through download, installation guide,
                            changelog links.</footer>
                        <footer class="blockquote-footer"> A12 = v2.0 (snow), A13 = v3.0 (tiramisu), A14 = v4.0 (uno)
                            and A15 = v5.0 (vany) respective branch.</footer>
                        <footer class="blockquote-footer"> Check out below link for older android version builds of
                            elixir on sourceforge.</footer>
                        <br>

                        <h1> <a target="_blank" href="https://sourceforge.net/projects/project-elixir/files/">
                                <a class="btn shadow footer-support-btn">Archived Builds</a>
                            </a></h1>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<br>

<!-- Download Page Back button -->
<p class="marT2 text-center"><a class="btn shadow footer-support-btn" [routerLink]="['/download']">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-paypal"
            viewBox="0 0 16 16">
            <path
                d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm3.5 7.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z" />
        </svg> Back </a></p>

<br>
<br>

<!-- Footer Support Card -->
<div class="bg-body " style="background-color: #ffebda; padding: 2rem; margin-bottom: -2rem;">
    <div class="row justify-content-center">
        <div class=" mb-3 card-radius">
            <div class="row no-gutters">

                <div class="col-md-6">
                    <div class="card-body">
                        <h1 class="support_line"> Wanna Support Us ? </h1>
                        <p class="patreon_highlight">Help to keep Project Elixir active and running by donating. Any
                            amount is appreciated.<strong>シ </strong>
                        </p>
                        <h1> <a href="https://projectelixiros.com/donate">
                                <a class="btn shadow footer-support-btn">Donate Now</a>
                            </a></h1>

                    </div>
                </div>

                <div class="col-md-6 mb-align" style="text-align: center;">
                    <img src="./assets/images/donate-phone-hand.webp" class="card-img img-fluid down-carpet-img"
                        style="width: 15rem;" alt="avatar">
                </div>

            </div>
        </div>
    </div>
</div>

<app-footer></app-footer>